import { Component, OnInit, Input, ElementRef, AfterViewInit } from '@angular/core';
import * as contac from '../../../assets/JsonEstructura/contac.json';
import { TraductorService } from '../../servicios/traductor.service';
import { Video } from '../../Models/video.model'
import { Subscription } from 'rxjs';
import { Map, View, Feature } from 'ol'
import { Icon, Style } from 'ol/style';
import {toSize} from 'ol/size';
import Overlay from 'ol/Overlay';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { Vector as VectorLayer, Vector } from 'ol/layer';
import * as Proj from 'ol/proj';
import { defaults as defaultControls } from 'ol/control';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';

const dataC = JSON.stringify(contac);
const dataIC = JSON.parse(dataC);
export const DEFAULT_HEIGHT = '550px';
export const DEFAULT_WIDTH = '500px';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
// Importante!!!! este componente es el componente de Contactanos
export class VideoComponent implements OnInit {

  public lat: number = 4.757456;
  public Lon: number = -74.1122391;
  public zoom: number = 4.9;
  public width: string | number = DEFAULT_WIDTH;
  public height: string | number = DEFAULT_HEIGHT;

  private mapEl: HTMLElement;

  map: Map;

  public data: any;
  public idioma: string;
  public titulos: any;
  public titulosIn: any;
  public titulosZh: any;
  public titulosFr: any;
  public titulosDe: any;
  public titulosRu: any;
  public titulosBr: any;
  public titulosKr: any;
  public suscriber: Subscription;

  constructor(
    private _traductorService: TraductorService,
    private elementRef: ElementRef
  ) {


    this.data = new Array(dataIC);
    this.idioma = localStorage.getItem("idioma");

    if (this.idioma == undefined) {

      this.suscriber = this._traductorService.getEvento().subscribe(
        result => {
          if (result) {
            if (result == 2) {
              this.idioma = "2"
              localStorage.setItem("idioma", this.idioma)

            } else if (result == 3) {
              this.idioma = "3"
              localStorage.setItem("idioma", this.idioma)

            } else if (result == 4) {
              this.idioma = "4"
              localStorage.setItem("idioma", this.idioma)

            } else if (result == 5) {
              this.idioma = "5"
              localStorage.setItem("idioma", this.idioma)

            } else if (result == 6) {
              this.idioma = "6"
              localStorage.setItem("idioma", this.idioma)

            }else if (result == 7) {
              this.idioma = "7"
              localStorage.setItem("idioma", this.idioma)
            }else if (result == 8) {
              this.idioma = "8"
              localStorage.setItem("idioma", this.idioma)
            }
          }
        },
        error => {
          console.log(error)
        }
      )
      this.titulos = new Video("", "", "", "", "");
      this.titulosIn = new Video("", "", "", "", "");
      this.titulosZh = new Video("", "", "", "", "");
      this.titulosFr = new Video("", "", "", "", "");
      this.titulosDe = new Video("", "", "", "", "");
      this.titulosRu = new Video("", "", "", "", "");
      this.titulosBr = new Video("", "", "", "", "");
      this.titulosKr = new Video("", "", "", "", "");

    }
    this._traductorService.getEvento().subscribe(
      result => {
        if (result) {
          if (result == 2) {
            this.idioma = "2"
          } else if (result == 3) {
            this.idioma = "3"
          } else if (result == 4) {
            this.idioma = "4"
          } else if (result == 5) {
            this.idioma = "5"
          } else if (result == 6) {
            this.idioma = "6"
          } else if (result == 7) {
            this.idioma = "7"
          } else if (result == 8) {
            this.idioma = "8"
          }
        }
      },
      error => {
        console.log(error)
      }
    );
  }

  ngOnInit(): void {

    this.mapEl = this.elementRef.nativeElement.querySelector('#map');
    this.setSize();

    for (let i = 0; i < this.data[0].default.titulos.length; i++) {
      this.titulos = new Video(this.data[i].default.titulos[i].Contactanos, this.data[i].default.titulos[i].Soporte, this.data[i].default.titulos[i].Estamos, this.data[i].default.titulos[i].disponible, "");
      this.titulosIn = new Video(this.data[i].default.titulos[i].ContactanosIn, this.data[i].default.titulos[i].SoporteIn, this.data[i].default.titulos[i].EstamosIn, this.data[i].default.titulos[i].disponibleIn, "");
      this.titulosZh = new Video(this.data[i].default.titulos[i].ContactanosZh, this.data[i].default.titulos[i].SoporteZh, this.data[i].default.titulos[i].EstamosZh, this.data[i].default.titulos[i].disponibleZh, "");
      this.titulosFr = new Video(this.data[i].default.titulos[i].ContactanosFr, this.data[i].default.titulos[i].SoporteFr, this.data[i].default.titulos[i].EstamosFr, this.data[i].default.titulos[i].disponibleFr, "");
      this.titulosDe = new Video(this.data[i].default.titulos[i].ContactanosDe, this.data[i].default.titulos[i].SoporteDe, this.data[i].default.titulos[i].EstamosDe, this.data[i].default.titulos[i].disponibleDe, "");
      this.titulosRu = new Video(this.data[i].default.titulos[i].ContactanosRu, this.data[i].default.titulos[i].SoporteRu, this.data[i].default.titulos[i].EstamosRu, this.data[i].default.titulos[i].disponibleRu, "");
      this.titulosBr = new Video(this.data[i].default.titulos[i].ContactanosBr, this.data[i].default.titulos[i].SoporteBr, this.data[i].default.titulos[i].EstamosBr, this.data[i].default.titulos[i].disponibleBr, "");
      this.titulosKr = new Video(this.data[i].default.titulos[i].ContactanosKr, this.data[i].default.titulos[i].SoporteKr, this.data[i].default.titulos[i].EstamosKr, this.data[i].default.titulos[i].disponibleKr, "");
    }

  }
  ngAfterViewInit(): void {

    //mapas y markers
    var iconBogota = new Feature({
      geometry: new Point(Proj.fromLonLat([-74.0541746,4.6994765])),
    });
    var iconStyleB = new Style({
      image: new Icon({
        src: 'assets/img/iconos/point.png',
        anchor:[0.10,45],
        scale: 0.07,
        anchorXUnits: IconAnchorUnits['FRACTION'],
        anchorYUnits: IconAnchorUnits["PIXELS"]
        
      })
    });
    var iconValle = new Feature({
      geometry: new Point(Proj.fromLonLat([-76.5381389,3.453892]))
    })
    var iconBuenaventura = new Feature({
      geometry: new Point(Proj.fromLonLat([-77.02801,3.8841927]))
    })
    var iconChile = new Feature({
      geometry: new Point(Proj.fromLonLat([-70.6095249,-33.4223508]))
    });
    var iconArgentina = new Feature({
      geometry: new Point(Proj.fromLonLat([-58.5883166,-34.4799568]))
    })
    var iconGuatemala = new Feature({
      geometry: new Point(Proj.fromLonLat([-90.5271964,14.5755707]))
    })
    var iconElSalvador = new Feature({
      geometry: new Point(Proj.fromLonLat([-89.2423427,13.7098435]))
    })
    var iconHonduras = new Feature({
      geometry: new Point(Proj.fromLonLat([-87.9913742,15.4910954]))
    })
    var iconManagua = new Feature({
      geometry: new Point(Proj.fromLonLat([-86.2636615,12.1256198]))
    })
    var iconPanama = new Feature({
      geometry: new Point(Proj.fromLonLat([-79.5252099,8.9758318]))
    })
    var iconCostaRica = new Feature({
      geometry: new Point(Proj.fromLonLat([-84.1413393,9.9298678]))
    })
    var iconMexico = new Feature({
      geometry: new Point(Proj.fromLonLat([-99.2282273,19.4661397]))
    })
    var iconMexico2 = new Feature({
      geometry: new Point(Proj.fromLonLat([-99.1899308,19.4373836]))
    })
    var iconPeru = new Feature({
      geometry: new Point(Proj.fromLonLat([-77.0347457,-12.0936138]))
    })
    //implementación de mapa y marcadores, (Layers)
    iconPeru.setStyle(iconStyleB)
    iconMexico2.setStyle(iconStyleB)
    iconMexico.setStyle(iconStyleB);
    iconCostaRica.setStyle(iconStyleB);
    iconPanama.setStyle(iconStyleB);
    iconManagua.setStyle(iconStyleB);
    iconHonduras.setStyle(iconStyleB);
    iconElSalvador.setStyle(iconStyleB);
    iconGuatemala.setStyle(iconStyleB);
    iconArgentina.setStyle(iconStyleB);
    iconChile.setStyle(iconStyleB);
    iconBuenaventura.setStyle(iconStyleB);
    iconValle.setStyle(iconStyleB);
    iconBogota.setStyle(iconStyleB);
    var vectorSource = new VectorSource({
      features: [
        iconBogota,
        iconValle,
        iconBuenaventura,
        iconChile,
        iconArgentina,
        iconGuatemala,
        iconElSalvador,
        iconHonduras,
        iconManagua,
        iconPanama,
        iconCostaRica,
        iconMexico,
        iconMexico2,
        iconPeru
      ],
    });
    var vectorLayer = new VectorLayer({
      source: vectorSource,
    });
    var mapaOpen = new TileLayer({
      source: new XYZ({
        url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      })
    })
    this.map = new Map({
      layers: [mapaOpen,vectorLayer],
      target: 'map',
      view: new View({
        center: Proj.fromLonLat([this.Lon, this.lat]),
        zoom: this.zoom
      }),
      controls: defaultControls().extend([])
    });
  }

  private setSize(): void {
    if (this.mapEl) {
      const styles = this.mapEl.style;
      styles.width = "100%"
      styles.height = coerceCssPixelValue(this.height) || DEFAULT_HEIGHT;
      //styles.width = coerceCssPixelValue(this.width) || DEFAULT_WIDTH;
    }
  }

}

const cssUnistsPattern = /([A-Za-z%]+)$/
function coerceCssPixelValue(value: any): string {
  if (value == null) {
    return '';
  }
  return cssUnistsPattern.test(value) ? value : `${value}px`;
}